import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { applyTheme } from '../lib/theme';
import { useSettingsStore } from '../store/settings';
import { useAuthStore } from '../store/auth';

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const { t } = useTranslation();
  const token = useAuthStore((s) => s.accessToken);
  const loadSetting = useSettingsStore((s) => s.loadSetting);
  const loaded = useSettingsStore((s) => s.loaded);

  useEffect(() => {
    applyTheme('warm-wood');
  }, []);

  useEffect(() => {
    if (token) {
      loadSetting();
    }
  }, [token, loadSetting]);

  if (token && !loaded) {
    return (
      <div className="h-screen flex items-center justify-center text-daynote-muted text-sm">
        {t('dayDetail.loading')}
      </div>
    );
  }

  return <>{children}</>;
}
